import { module } from 'stereomodularjs';
import gsap from 'gsap';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(SplitText);

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        // Supprimer les balises <br> si la largeur de la fenêtre est inférieure à 500 pixels
        if (window.innerWidth < 600) {
            this.el.innerHTML = this.el.innerHTML.replace(/<br\s*\/?>/gi, ' ');
        }

        this.el.innerHTML = this.el.innerHTML.replace("-", "<span>-</span>");
        this.splitWords = new SplitText(this.el, { type: 'words', wordsClass: 'u-anim-word' });
        this.words = this.splitWords.words;
    }

    destroy() {
        
    }
}
